export type ExtractedData<T extends {name: string}> = Omit<T, 'name'>;

export class TransformUtils {
  static transformNamedItemsArrayToObject = <T extends {name: string}>(
    array: T[],
  ): Record<string, ExtractedData<T>> => {
    return array.reduce((acc, item) => {
      const {name, ...data} = item;

      return {
        ...acc,
        [name]: data,
      };
    }, {});
  };

  static notEmpty<TValue>(value: TValue | null | undefined): value is NonNullable<TValue> {
    return value !== null && value !== undefined;
  }
}
